import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=4233fffc&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=4233fffc&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4233fffc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4233fffc')) {
      api.createRecord('4233fffc', component.options)
    } else {
      api.reload('4233fffc', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=4233fffc&scoped=true&", function () {
      api.rerender('4233fffc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4OfNen6H71g7H/JS/comp/Paginate.vue"
export default component.exports